import "@babel/polyfill";
import { PubSub } from 'pubsub-js';
import jquery from "jquery";
import { charts } from '../config/dataservices';
import { mapServices } from '../config/dataservices';

/**
 * Never Modify ApplicationState property outside of this class directly.
 * Always Use Corrosponding getter, setter or pub sub event methods
 */
let ApplicationState = {
  geoid: null,
  fromYear: null,
  toYear: null,
  chartsData: {},
  regionType: "counties",
  state: "",
  location: "",
  activeLandCoverLayer: "none",
  basemap: "satellite",
  locationExtent: "",
  tab: 1,
  changeLayerVisible: true
}

export class DataService {

  static instance;

  constructor(options) {
    if (this.instance) {
      return this.instance;
    }

    this.instance = this;

    options = options || {};

    this.logServiceResponseToConsole = false
  }

  static get ApplicationState() {
    return ApplicationState;
  }

  async makeRequest(url, geoid, fromYear, toYear) {
    return jquery.ajax({
      url: url,
      dataType: "jsonp",
      data: {
        GeoId: geoid,
        StartDate: fromYear,
        EndDate: toYear,
        f: 'jsonp'
      }
    });
  }

  async makeFootprintRequest(geoid) {
    let url = mapServices.boundaries+geoid;    
    return jquery.ajax({
      url: url
    });
  }

  getDebugServices() {
    return this.logServiceResponseToConsole;
  }

  setLocationExtent(extent) {
    ApplicationState.locationExtent = extent.join(',');
  }

  setTab(tab) {
    if (["general", "developed", "forests", "wetlands", "agriculture"].includes(tab)) {
      this.emit('tabChange', { tab }, null);
      ApplicationState.tab = ["general", "developed", "forests", "wetlands", "agriculture"].indexOf(tab) + 1
    }
    else {
      console.error("Incorrect tab value set. Acceptable values are ")
    }
  }

  setActiveLandCoverLayer(landCoverLayer) {
    ApplicationState.activeLandCoverLayer = landCoverLayer;
    this.emit('landCoverLayerChange', { landCoverLayer }, null);
  }

  setActiveBasemap(basemap) {
    ApplicationState.basemap = basemap;
    this.emit('basemapChange', { basemap }, null);
  }
  
  setChangeVisibility(changeLayerVisible) {
    ApplicationState.changeLayerVisible = changeLayerVisible;
    this.emit('toggleDifferenceLayer', { changeLayerVisible }, null);
  }

  get(geoid, fromYear, toYear, regionType, state, stateFIPS, location) {

    //notify charts that new data is loading
    this.emit('loadingData', null);

    //load chart data and notify listeners
    charts.forEach(url => {
      this.makeRequest(url, geoid, fromYear, toYear)
        .then(data => {
          let eventKey = url.split('/').pop();
          let outputData = data;
          outputData.fromYear = fromYear;
          outputData.toYear = toYear;
          this.emit(eventKey, outputData, null);
        }, data => {
          let eventKey = url.split('/').pop();
          this.emit(eventKey, null, {
            message: 'Service Failed',
            url: url,
            data: data
          });
        })
    });

    //load footprint from arcgis and geoidChange listeners
    if (geoid.trim() !== ApplicationState.geoid) {
      this.makeFootprintRequest(geoid.trim()).then(data => {
        this.emit("geoidChange", data, null);
      }, data => {
        this.emit("geoidChange", null, {
          message: 'Boundaries Map Service Failed',
          data: data
        });
      });
    }

    //notify fromYearChange listeners
    if (+fromYear.trim() !== ApplicationState.fromYear) {
      this.emit("fromYearChange", {
        oldValue: ApplicationState.fromYear,
        newValue: +fromYear.trim(),
      }, null);
    }

    //notify toYearChange listeners
    if (+toYear.trim() !== ApplicationState.toYear) {
      this.emit("toYearChange", {
        oldValue: ApplicationState.toYear,
        newValue: +toYear.trim(),
      }, null);
    }

    //update app state
    ApplicationState.geoid = geoid.trim();
    ApplicationState.fromYear = +fromYear.trim();
    ApplicationState.toYear = +toYear.trim();
    ApplicationState.regionType = regionType;
    ApplicationState.state = state;
    ApplicationState.stateFIPS = +stateFIPS.trim();
    ApplicationState.location = location;

    //console.log(ApplicationState);
  }

  /**
   * [on enables subscriptions to events emmited by DataService Class]
   * @param  {String} event [Published events include all keys available in config/charts.js eg: 'general.chart1' ]
   * @param  {Function} callback  [description]
   * @return {Object} [token object to represent the subscription]
   */
  on(event, callback) {
    return PubSub.subscribe(event, callback);
  }

  /**
   * [off Unsubscribe from event using the token returned from 'on' function]
   * @param  {Object} token [description]
   * @return {null}
   */
  off(token) {
    PubSub.unsubscribe(token);
  }

  emit(event, data, error) {
    PubSub.publish(event, {
      data: data,
      error: error
    });
  }
}